export const getProfilePageSteps = (t) => [
    {
        target: '[data-tour="pp-card"]',
        placement: 'center',
        title: t('tour.profilePage.step-welcome-title'),
        content: t('tour.profilePage.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="pp-referral"]',
        title: t('tour.profilePage.step-referral-title'),
        content: t('tour.profilePage.step-referral-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="pp-gcal"]',
        title: t('tour.profilePage.step-gcal-title'),
        content: t('tour.profilePage.step-gcal-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="pp-mscal"]',
        title: t('tour.profilePage.step-mscal-title'),
        content: t('tour.profilePage.step-mscal-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="pp-acal"]',
        title: t('tour.profilePage.step-acal-title'),
        content: t('tour.profilePage.step-acal-content'),
        disableBeacon: true,
    },
];
